/**
 * @file コンポーネント：利用規約確認モーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContent = styled.div``;

export const StyledContentHeader = styled.header`
    margin-bottom: 24px;
`;

export const StyledContentHeaderLogo = styled.h2`
    margin-bottom: 12px;
    text-align: center;
`;

export const StyledContentHeaderLogoImage = styled.img``;
